module.exports = __webpack_public_path__ + "static/media/burger@2x.657b3a19.jpg";